<template>
  <div class="action">
    <button @click="changePassword" class="btn-savePwd">Neues Passwort<br>speichern</button>
  </div>
</template>

<script>
export default {
    name: "ActionPanelChangePwd",
    setup(props, context) {
        const changePassword = () => {
          console.log('changePassword')
          context.emit('changePassword');
        }
        
        
        return {changePassword}
    }
}
</script>

<style scoped>
.action {
    background-color: #ddd;
    display:flex;
    justify-content: space-around;
    align-items: center;
}

.btn-savePwd {
  background-color: crimson;
  color: white;
  border: none;
  border-radius: 15px;
  outline: none;
  padding: 10px 0;
  margin: 0;
  width: 150px;
  font-size: 16px;
}
</style>